import React, { useEffect, useRef, useState } from 'react';
import {
  attachDeferralListeners,
  shouldDeferError,
  suppressErrorProps,
} from './deferredValidationCore';

export { shouldDeferError, suppressErrorProps } from './deferredValidationCore';

export default function withDeferredValidation(BaseField) {
  function DeferredValidationField(props) {
    const containerRef = useRef(null);
    const [interacted, setInteracted] = useState(false);
    const [submitAttempted, setSubmitAttempted] = useState(false);

    useEffect(
      () =>
        attachDeferralListeners(containerRef.current, {
          onInteract: () => setInteracted(true),
          onSubmitAttempt: () => setSubmitAttempted(true),
        }),
      [],
    );

    const fieldProps = shouldDeferError({ interacted, submitAttempted })
      ? suppressErrorProps(props)
      : props;

    return (
      <div ref={containerRef} className="deferred-validation-field">
        <BaseField {...fieldProps} />
      </div>
    );
  }

  DeferredValidationField.displayName = `withDeferredValidation(${
    BaseField?.displayName || BaseField?.name || 'Field'
  })`;

  return DeferredValidationField;
}
